<template>
  <component v-bind:is="componentType" :content="value" :revealed="revealed">
  </component>
</template>

<script>
import Cencored from './Cencored.vue'
import Term from './Term.vue'

export default {
  computed: {
    componentType() {
      try {
        return this.type
      } catch (err) {
        return {}
      }
    }
  },
  components: {
    Cencored, // eslint-disable-line vue/no-unused-components
    Term // eslint-disable-line vue/no-unused-components
  },
  props: {
    value: [String, Array],
    type: String,
    revealed: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
